import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * Collapse state of the sidebar submenu panel (the space list shown next to
 * the icon bar for Community / Programs). Shared between the sidebar (which
 * renders the panel + toggle buttons) and SubNavPageContainer (which offsets
 * the page content). Persisted so the choice survives reloads.
 */
const submenuCollapsedAtom = atomWithStorage<boolean>('sidebar-submenu-collapsed', false);

export const useSubmenuCollapse = () => {
  const [isSubmenuCollapsed, setIsSubmenuCollapsed] = useAtom(submenuCollapsedAtom);

  return {
    isSubmenuCollapsed,
    toggleSubmenu: () => setIsSubmenuCollapsed(prev => !prev),
    // Clicking a nav item that owns a submenu (Programs / Community) always
    // opens the panel — there is no expand button on the collapsed rail.
    expandSubmenu: () => setIsSubmenuCollapsed(false),
  };
};
